





import React from 'react';
import TimeCountDown from '../TimeCountDown/TimeCountDown';
import './style.css'

const Saveday = () => {

    return (
        <div id="home" className="hero-container">
 
                {/* <div className="container"> */}
                <div className="hero-flex">
                            <div className="hero-side h-start">
                                {/* <img src='https://media.vogue.fr/photos/64819b5475cede9af1c0707a/3:4/w_2560%2Cc_limit/1349465407' alt="Wedding" /> */}
                            </div>
                            <div className="hero-center">
                            {/* <img id="letters" src='/images/tanda-letters.png' alt='w'/> */}
                            <img id="letters" src='/images/TandA-Intro-Logo.png' alt='w'/>

                            <span className="date-place">
                            Σάββατο <br/>
                            Πρωταράς, Κύπρος
                                </span>
                            <TimeCountDown />

                            {/* <div class="btn-w d-flex"><a href='#rsvp'>RSVP</a> <img  src='/images/arrow-down.png' alt='w'/>
                            </div> */}

                            <p className="poem">
                            «Σ’ αγαπώ μη γνωρίζοντας πώς, από πού και πότε, 
                            <br/>
                            σ’ αγαπώ στα ίσια δίχως πρόβλημα ή περηφάνια:
                            <br/>
                            σ’ αγαπώ έτσι γιατί δεν ξέρω μ’ άλλον τρόπο
                            <br/>
                            παρά μ’ ετούτον όπου δεν είμαι μήτε είσαι, 
                            <br/>
                            που το χέρι σου πάνω μου το νιώθω σαν δικό μου, 
                            <br/>
                            που όταν κοιμάμαι κλείνουν και τα δικά σου μάτια.»
                            </p>
                            </div>
                            <div className="hero-side h-end">
                                {/* <img src='https://images.bild.de/646f6e96e6924c377c327758/14d5cae1e1f8756f98792c27c4d2159f,ee78dcf1?w=992' alt="Wedding" /> */}
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-4 col-md-4 section-area">
                                <img src='https://media.vogue.fr/photos/64819b5475cede9af1c0707a/3:4/w_2560%2Cc_limit/1349465407' alt="Wedding" />
                            </div>
                            <div className="col-4 col-md-4 section-area">
                            <img src='https://e7.pngegg.com/pngimages/723/100/png-clipart-olive-branch-graphy-olive-leaf-miscellaneous-leaf-thumbnail.png' alt='w'/>
                            <TimeCountDown />
                            </div>
                            <div className="col-4 col-md-4 section-area">
                                <img src='https://images.bild.de/646f6e96e6924c377c327758/14d5cae1e1f8756f98792c27c4d2159f,ee78dcf1?w=992' alt="Wedding" />
                            </div>
                        </div> */}
                {/* </div> */}
        </div>
    );
}

export default Saveday;